import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import mainPage from "./views/mainPage.vue";
import testEmbed from "../src/test/embedPage.vue";
import { IonicVueRouter } from "@ionic/vue";

Vue.use(IonicVueRouter);

export default new IonicVueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path:'/',
    //   name:'mainPage',
    //   component:mainPage
    // },
    {
      path: "/",
      name: "home",
      component: Home
    }

    // {
    //   path:'/erauLog',
    //   beforeEnter(to, from, next) {
    //     window.location  = 'https://emids.near.aero/Shibboleth.sso/Login?entityID=https%3A%2F%2Ffed.erau.edu/fed/idp&target=https%3A%2F%2Femids.near.aero%2Fmain.html'
    //   }
    // },
    // {
    //   path:'/erauLog',
    //   name:'testEmbed',
    //   component:testEmbed
    // },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
});
